import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=5670cc00"
import script from "./SingleSelect.vue?vue&type=script&lang=js"
export * from "./SingleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports